export const BOTTOM_MAP_CARDS = {
	boothData: 'boothData'
};
